import request from './api/request'
import utils from '@/utils/index'
import pfile from '@/utils/secretkey/pfile'
import sfile from '@/utils/secretkey/sfile'

var ak = utils.genak()
var ed = utils.re(ak, unescape(pfile)) //秘钥

function decrypt(data) {
  if (data?.ak) {
    let plaintext = utils.rd(data.ak, unescape(sfile))
    let obj = utils.secret(data.ed, plaintext, true)
    return JSON.parse(obj)
  } else {
    return data
  }
}

function inParameter(data) {
  if (data) {
    return { sn: ed, jt: utils.secret(data, ak) }
  } else {
    return data
  }
}
//获取滑块数据
export function getSliderInfoAPI(data) {
  return request({
    url: '/validate-service/slider/info',
    method: 'post',
    data,
  }).catch(err => {})
}

//上传图片
export function getUpTask(data) {
  return request({
    url: '/sysFile/getDirectAvatarUploadLink',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
//获取热门数据
export function getHotList(data) {
  return request({
    url: '/cloud/getHotData',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
//登录
export function LoginSSOAPI(data) {
  return request({
    url: `/sso/login?&token=${data.token}`,
    method: 'get',
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
//获取用户信息
export function userInfoAPI(data) {
  return request({
    url: '/center/getuserV2',
    method: 'post',
    data,
  })
    .then(res => {
      return res
    })
    .catch(err => {})
}
//退出登录
export function loginOutAPI(data) {
  return request({
    url: '/user/loginout',
    method: 'post',
    data,
  })
    .then(res => {
      return res
    })
    .catch(err => {})
}
//获取用户消息
export function getMsgNumAPI(data) {
  return request({
    url: '/userMsg/getMsgNum',
    method: 'post',
    data,
  })
    .then(res => {
      return res
    })
    .catch(err => {})
}
//获取收藏消息
export function getCollectNumAPI(data) {
  return request({
    url: '/cloud/getFavoriteNum',
    method: 'post',
    data,
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
//获取表情
export function getEmojiAPI(data) {
  return request({
    url: '/jx/getEmoji',
    method: 'post',
    data: inParameter(data),
  })
    .then(res => {
      res.data = decrypt(res.data)
      return res
    })
    .catch(err => {})
}
